import { ActionType, createAction } from 'typesafe-actions'

import { Domain, DomainType } from '../../domains'

import { ValidatedImportItems } from './types'

export const ImportValidationActions = {
  fetchData: createAction('IMPORT-VALIDATIONS/load-data')<{
    importId?: string
    page: number
    pageSize: number
  }>(),
  setData: createAction('IMPORT-VALIDATIONS/set-data')<{
    page: number
    totalPages: number
    data: ValidatedImportItems
  }>(),
  setEnabled: createAction('IMPORT-VALIDATIONS/set-enabled')<{
    itemId: string
    enabled: boolean
  }>(),
  setAllEnabled: createAction('IMPORT-VALIDATIONS/set-all-enabled')<{
    enabled: boolean
  }>(),
  exportResults: createAction('IMPORT-VALIDATIONS/export-validation-results')<{
    columns: { id: string; label: string }[]
    validationErrors: { id: string; label: string }[]
    businessIdTypes: { id: string; label: string }[]
    name: string
    domains?: Partial<Record<DomainType, Domain>>
  }>(),
  downloadExport: createAction('IMPORT-VALIDATIONS/download-export')<{ exportId: string }>()
}

export type ImportValidationActions = ActionType<typeof ImportValidationActions>
